/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function hostReportError(err) {
    setTimeout(function () { throw err; }, 0);
}
//# sourceMappingURL=hostReportError.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/hostReportError.js
// module id = 388
// module chunks = 1